<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.itemPackMaintain')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{ span: 8 }" :model="data" :rules="rules" :wrapper-col="{ span: 16 }">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemNo')">
            <vxe-input v-model="data.item.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <vxe-input v-model="data.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.dataSource')" prop="dataSource">
            <vxe-select v-model="data.dataSource" :options="dataSources" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.specification')" prop="specification">
            <vxe-input v-model="data.specification" :disabled="data.dataSource!==4" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.uom')" prop="uom">
            <vxe-input v-model="data.uom" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.factor')" prop="factor">
            <vxe-number-input v-model="data.factor" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.innerFactor')" prop="innerFactor">
            <vxe-number-input v-model="data.innerFactor" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.length')" prop="dimension.length">
            <vxe-number-input v-model="data.dimension.length" :min="0" :suffixConfig="{content:$t('col.uomOfDimension')}" style="width: 100%" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.width')" prop="dimension.width">
            <vxe-number-input v-model="data.dimension.width" :min="0" :suffixConfig="{content:$t('col.uomOfDimension')}" style="width: 100%" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.height')" prop="dimension.height">
            <vxe-number-input v-model="data.dimension.height" :min="0" :suffixConfig="{content:$t('col.uomOfDimension')}" style="width: 100%" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.volume')" prop="dimension.volume">
            <vxe-number-input v-model="data.dimension.volume" :min="0" :suffixConfig="{content:$t('col.uomOfVolume')}" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.weight')">
            <vxe-number-input v-model="data.weight" :min="0" :suffixConfig="{content:$t('col.uomOfWeight')}" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.barcode')">
            <vxe-input v-model="data.barcode" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.shape')" prop="shape">
            <vxe-select v-model="data.shape" :options="shapes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.robotArmNumber')">
            <vxe-number-input v-model="data.ordinal" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.master')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.master" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.wrapping')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.wrapping" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.catchWeight')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.catchWeight" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.transportable')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.transportable" size="mini"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoPalletization')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoPalletization" size="mini"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { findOne, save } from '@/api/Api'
import { Pack } from '@/api/dto/common/Pack'

export default {
  name: 'PackEditor',
  props: {
    dataSources: { type: Array, default: [] },
    shapes: { type: Array, default: [] }
  },
  data() {
    return {
      visible: false,
      loading: false,
      data: new Pack(),
      rules: {
        specification: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        uom: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        factor: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        innerFactor: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.length': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.width': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.height': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'dimension.volume': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        shape: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    onDimensionChange() {
      this.data.dimension.volume = this.data.dimension.length * this.data.dimension.width * this.data.dimension.height
    },
    add(item) {
      this.visible = true
      this.data = new Pack()
      this.data.available = true
      this.data.item = item
      this.data.dataSource = 4
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('packFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new Pack(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      save('packPersister', data).then(res => {
        if (res.success) {
          this.data = new Pack(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>